module.exports = __webpack_public_path__ + "static/media/Madhavan.a8ecebe5.png";